import React, { useState } from 'react';
import './Docs.css';

/**
 * Docs — internal documentation tab.
 *
 * The wireframe/spec HTML pages produced during design review
 * (frontend-web/public/docs/*.html — mirrored from the mp-docs project)
 * are embedded here rather than rebuilt as React views. `index.html` is
 * already a self-contained internal-docs hub that iframes the individual
 * flow pages itself, so all we need to do is host the static files and
 * point one sandboxed <iframe> at it.
 *
 * Layout: 5% margin on each side (not the app's usual container/max-width)
 * with the doc viewer filling ~80% of the viewport height, below a compact
 * header. The navbar stays; the global footer is hidden for this route in
 * App.jsx (ConditionalFooter).
 *
 * Sandboxing: the docs carry their own inline <script> tags (for slider
 * interactions, tab switching, etc.) and pull Tailwind/fonts/icons from
 * CDNs, so we can't just inject the markup as a string — it needs to run
 * as its own document. `sandbox="allow-scripts allow-popups"` lets that
 * JS execute while deliberately leaving out `allow-same-origin`, which
 * keeps the iframe in a distinct opaque origin: it cannot read/write the
 * parent app's cookies, localStorage (where the auth token lives), or DOM,
 * and it cannot navigate the top-level window.
 */
const Docs = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <main className="docs-page">
      <div className="docs-page__header">
        <h1 className="docs-page__title">Documentation</h1>
        <p className="docs-page__sub">
          Internal wireframes and product specs — visible to the client and dev team while MarginPro is in development.
        </p>
      </div>

      <div className="docs-frame-wrap">
        {!loaded && (
          <div className="docs-frame__loading">
            <span className="auth-gate-loading__spinner" />
          </div>
        )}
        <iframe
          title="MarginPro Internal Documentation"
          src={`${process.env.PUBLIC_URL}/docs/index.html`}
          className="docs-frame"
          sandbox="allow-scripts allow-popups"
          referrerPolicy="no-referrer"
          onLoad={() => setLoaded(true)}
        />
      </div>
    </main>
  );
};

export default Docs;
